module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Productdetails"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default",
    staticStyle: {
      "display": "block"
    }
  }, [_c('h6', [_vm._v("Nieuwe order notificatie")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('form', {
    attrs: {
      "onsubmit": "return false"
    }
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Barcode"
    }
  }, [_vm._v("Notificatie tekst:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderNotification.notification_text),
      expression: "orderNotification.notification_text"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.orderNotification.notification_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderNotification, "notification_text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Location"
    }
  }, [_vm._v("Bedrag:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderNotification.amount),
      expression: "orderNotification.amount"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.orderNotification.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderNotification, "amount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v("Merken:")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "multiple": true,
      "options": _vm.brands,
      "placeholder": "Selecteer merken",
      "selected-label": "✔",
      "select-label": "",
      "deselect-label": "✔",
      "allow-input": ""
    },
    model: {
      value: (_vm.orderNotification.settings.brands),
      callback: function($$v) {
        _vm.$set(_vm.orderNotification.settings, "brands", $$v)
      },
      expression: "orderNotification.settings.brands"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderNotification.settings.exclude_sale_products),
      expression: "orderNotification.settings.exclude_sale_products"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.orderNotification.settings.exclude_sale_products) ? _vm._i(_vm.orderNotification.settings.exclude_sale_products, null) > -1 : (_vm.orderNotification.settings.exclude_sale_products)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.orderNotification.settings.exclude_sale_products,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.orderNotification.settings, "exclude_sale_products", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.orderNotification.settings, "exclude_sale_products", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.orderNotification.settings, "exclude_sale_products", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Sales producten uitsluiten:\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderNotification.status),
      expression: "orderNotification.status"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.orderNotification.status) ? _vm._i(_vm.orderNotification.status, null) > -1 : (_vm.orderNotification.status)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.orderNotification.status,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.orderNotification, "status", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.orderNotification, "status", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.orderNotification, "status", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Actief\n                      ")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Opslaan\n              ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea24bf88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/settings/OrderNotificationEditModal.vue
// module id = 761
// module chunks = 1